// Role names for copy. The API's GET /roles is the source when loaded; the fallback
// names match packages/domain ROLES so permission-denied copy works without it.
import type { Role, Session } from '@bcio-voice/contracts';

const FALLBACK_NAMES: Record<string, string> = {
  owner: 'Tenant owner',
  admin: 'Administrator',
  supervisor: 'Supervisor',
  agent: 'Agent',
  analyst: 'Analyst',
};

export function roleName(id: string, catalog?: readonly Role[] | null): string {
  return catalog?.find(role => role.id === id)?.name ?? FALLBACK_NAMES[id] ?? id;
}

export function joinWords(words: readonly string[]): string {
  if (words.length === 0) return '';
  return new Intl.ListFormat(undefined, { style: 'long', type: 'conjunction' }).format(words);
}

export function roleNames(ids: readonly string[], catalog?: readonly Role[] | null): string {
  return joinWords(ids.map(id => roleName(id, catalog)));
}

/** The viewer's role IDs in the current tenant, from Session.memberships. */
export function currentRoleIds(session: Session): string[] {
  const tenantId = session.tenant?.id;
  return session.memberships.find(membership => membership.tenant_id === tenantId)?.role_ids ?? [];
}
